import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import NoticeModal from "views/components/NoticeModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import StateMasterCharge from "./StateMasterCharge";

const StateMasterCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();

  const [codeData, setCode] = useState(
    params.stateCode ? params.stateCode : ""
  );
  const [codeState, setCodeState] = useState(false);
  const code = codeData?.replace(/[^a-z0-9_]/gi, "");
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [gstNumber, setGSTNumber] = useState("");
  const [gstNumberState, setGSTNumberState] = useState(false);
  const [gstCode, setGSTCode] = useState("");
  const [gstCodeState, setGSTCodeState] = useState(false);
  const [cgstPercentage, setCGSTPercentage] = useState("");
  const [cgstPercentageState, setCGSTPercentageState] = useState(false);
  const [sgstPercentage, setSGSTPercentage] = useState("");
  const [sgstPercentageState, setSGSTPercentageState] = useState(false);
  const [igstPercentage, setIGSTPercentage] = useState("");
  const [igstPercentageState, setIGSTPercentageState] = useState(false);
  const [language, setLanguage] = useState("");
  const [languageState, setLanguageState] = useState(false);
  const [rawDataDataStateMaster, setRawDataStateMaster] = useState({});
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [minAmount, setMinAmount]= useState('');
  const [maxAmount, setMaxAmount]=useState('');
  const [charges, setCharges]=useState('');
  const [value, setValue]=useState('');
  const [chargeDetials, setChargeDetails]= useState('')
  const [gstApplicable, setGstApplicable]= useState(true)
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
const [chargesShow, setChargesShow]=useState(true)
  useEffect(() => {
    (async () => {
      if (params.stateCode) {
        setCallInProgress(true);
        // Get Data from API
        const stateMasterDetails = await apiHandler({
          url: endpoint.MASTER_STATE_FIND_BY_CODE + params.stateCode,
          authToken: authToken,
        });
        setCallInProgress(false);
        setRawDataStateMaster(stateMasterDetails.data || "");
        setCode(stateMasterDetails.data.code || "");
        setName(stateMasterDetails.data.name  || "");
        setGSTNumber(stateMasterDetails.data.gstNumber || "");
        setGSTCode(stateMasterDetails.data.gstCode || "");
        setCGSTPercentage(stateMasterDetails.data.cgstPercentage || "");
        setSGSTPercentage(stateMasterDetails.data.sgstPercentage || "");
        setIGSTPercentage(stateMasterDetails.data.igstPercentage || "");
        setLanguage(stateMasterDetails.data.language || "");
        setCharges(stateMasterDetails.data.chargeType || "");
        setValue(stateMasterDetails.data.value || "");
        setMaxAmount(stateMasterDetails.data.maxAmt || "");
        setMinAmount(stateMasterDetails.data.minAmt || "");
        setChargeDetails(stateMasterDetails.data.chargeNature || "")
        setGstApplicable(stateMasterDetails.data.gstApplicable || "")
      }
    })();
  }, []);
  // message popup
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
    if (code === "") {
      setCodeState(true);
    } else {
      setCodeState(false);
    }
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (gstNumber === "") {
      setGSTNumberState(true);
    } else {
      setGSTNumberState(false);
    }
    if (gstCode === "") {
      setGSTCodeState(true);
    } else {
      setGSTCodeState(false);
    }
    if (cgstPercentage === "") {
      setCGSTPercentageState(true);
    } else {
      setCGSTPercentageState(false);
    }
    if (sgstPercentage === "") {
      setSGSTPercentageState(true);
    } else {
      setSGSTPercentageState(false);
    }
    if (igstPercentage === "") {
      setIGSTPercentageState(true);
    } else {
      setIGSTPercentageState(false);
    }
    if (language === "") {
      setLanguageState(true);
    } else {
      setLanguageState(false);
    }
    if (
      code &&
      name &&
      gstNumber &&
      gstCode&&
      cgstPercentage &&
      sgstPercentage &&
      igstPercentage &&
      language
    ) {
      return true;
    } else {
      return false;
    }
  };

  const editStateMasterInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_STATE_UPDATE,
      method: "PUT",
      authToken: authToken,
      data: {
        code: code,
        name: name,
        gstNumber: gstNumber,
        cgstPercentage: cgstPercentage,
        sgstPercentage: sgstPercentage,
        igstPercentage: igstPercentage,
        language: language,
        chargeNature: chargeDetials,
        chargeType:charges,
        value: value,
        gstCode:gstCode,
        minAmt: chargeDetials === "FLAT" ? value : minAmount || '0',
        maxAmt: chargeDetials === "FLAT" ? value : maxAmount,
        gstApplicable: gstApplicable,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const handlestateMasterSubmit = async (event) => {
    if (isValidated()) {
      setNoticeModal(false);
      setNoticeModalErrMsg("");
      setNoticeModalHeaderMsg("");

      let status = "";
      if (params.stateCode) {
        status = await editStateMasterInformation();
      } else {
        setNoticeModalErrMsg("new State Master is not supported yet!");
        setNoticeModalHeaderMsg("Information");
        setNoticeModal(true);
        setRedirectURL(``);
      }
      if (status === "SUCCESS") {
        const msg = params.stateCode
          ? "StateMaster updated successfully!"
          : "StateMaster created successfully!";
        setNoticeModalErrMsg(msg);
        setNoticeModalHeaderMsg("Information");
        setNoticeModal(true);
        setRedirectURL(`/coreservice/state`);
      }
    }
  };
  const deleteCharges = () =>{
    setChargeDetails("");
    setValue("");
    setMaxAmount("");
    setMinAmount("");
    setCharges("");
    setChargesShow(false)
  }
  const handlecancelstateMaster = () => {
    navigate("/coreservice/state");
  };
  const handleChange = (e,name) => {
    const regex = /^\d*\.?\d*$/;
    if (name ==="CGST" && (e === "" || regex.test(e))) {
      setCGSTPercentage(e);
    }
    else if(name ==="SGST" && (e === "" || regex.test(e))){
      setSGSTPercentage(e);
    }
    else if(name ==="IGST" && (e === "" || regex.test(e))){
      setIGSTPercentage(e);
    }
    else if(name ==="value" && (e === "" || regex.test(e))){
      setValue(e);
    }
    else if(name ==="minAmount" && (e === "" || regex.test(e))){
      setMinAmount(e);
    }
    else if(name ==="maxAmount" && (e === "" || regex.test(e))){
      setMaxAmount(e);
    }
  };
  const handlegstValue =(e)=>{
    const regEx = /^[a-zA-Z0-9]*$/;
    if (e === "" || regEx.test(e)) {
      setGSTNumber(e);
    }
  }
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label="Edit State Master"
            button1=" Save"
            button2=" Cancel"
            button1click={handlestateMasterSubmit}
            button2click={handlecancelstateMaster}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer}>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Code"
                required
                error={codeState}
                id="lp_branch_code"
                value={code || ""}
                setState={setCode}
                maxLength="3"
                setError={setCodeState}
                disabled
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Name"
                required
                error={nameState}
                id="lp_branch_name"
                disabled
                value={name || ""}
                setState={setName}
                setError={setNameState}
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="GST Number"
                required
                error={gstNumberState}
                id="lp_statemasternumber"
                value={gstNumber || ""}
                setState={handlegstValue}
                setError={setGSTNumberState}
                type="gst"
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="GST Code"
                required
                error={gstCodeState}
                id="lp_stategstCode"
                value={gstCode || ""}
                setState={setGSTCode}
                setError={setGSTCodeState}
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="CGST Percentage"
                required
                error={cgstPercentageState}
                id="lp_statemastercgstpercentage"
                value={cgstPercentage || ""}
                setState={(e)=>handleChange(e,"CGST")}
                setError={setCGSTPercentageState}
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="SGST Percentage"
                required
                error={sgstPercentageState}
                id="lp_statemastersgst"
                value={sgstPercentage || ""}
                setState={(e)=>handleChange(e,"SGST")}
                setError={setSGSTPercentageState}
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="IGST Percentage"
                required
                error={igstPercentageState}
                id="lp_statemasterigstpercentage"
                value={igstPercentage || ""}
                setState={(e)=>handleChange(e,"IGST")}
                setError={setIGSTPercentageState}
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Language"
                required
                error={languageState}
                id="lp_statemasterigstpercentage"
                value={language || ""}
                setState={setLanguage}
                setError={setLanguageState}
              />
            </Grid>
          </Grid>
       { chargesShow && charges &&  <StateMasterCharge 
              classes={classes}
              Charges={charges}
              value={value}
              setValue={(e)=>handleChange(e,"value")}
              minAmount={minAmount}
              setMaxAmount={(e)=>handleChange(e,"maxAmount")} 
              maxAmount={maxAmount} 
              setMinAmount={(e)=>handleChange(e,"minAmount")}
              chargeDetials={chargeDetials}
              setChargeDetails={setChargeDetails}
              gstApplicable={gstApplicable}
              setGstApplicable={setGstApplicable}
              deleteCharges={deleteCharges}
              />}
        </Grid>       
      </Grid>
      <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        noticeModalErrMsg={noticeModalErrMsg}
        closeModal={closeNoticeModal}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

export default StateMasterCreate;
